import { useEffect } from "react";

/**
 * Cierra con ESC cuando enabled === true.
 * Llamalo SIEMPRE (no condicional) y controlá con el flag.
 */
export default function useEscClose(onClose, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const onEsc = () => {
      if (typeof onClose === "function") onClose();
    };

    window.addEventListener("app:esc", onEsc);
    return () => window.removeEventListener("app:esc", onEsc);
  }, [onClose, enabled]);
}
